type HomeFailureMap<R> = {
  serverFailure: () => R;
  networkFailure: () => R;
};

type HomeFailureMaybeMap<R> = {
  serverFailure?: () => R;
  networkFailure?: () => R;
  orElse: () => R;
};

abstract class _HomeFailure extends Error {
  public abstract map<R>(callbacks: HomeFailureMap<R>): R;
  public abstract maybeMap<R>(callbacks: HomeFailureMaybeMap<R>): R;
}

class ServerFailure extends _HomeFailure {
  constructor() {
    super("ServerFailure");
  }

  public map<R>(callbacks: HomeFailureMap<R>): R {
    return callbacks.serverFailure();
  }

  public maybeMap<R>(callbacks: HomeFailureMaybeMap<R>): R {
    if (callbacks.serverFailure) return callbacks.serverFailure();
    return callbacks.orElse();
  }
}

class NetworkFailure extends _HomeFailure {
  constructor() {
    super("NetworkFailure");
  }

  public map<R>(callbacks: HomeFailureMap<R>): R {
    return callbacks.networkFailure();
  }

  public maybeMap<R>(callbacks: HomeFailureMaybeMap<R>): R {
    if (callbacks.networkFailure) return callbacks.networkFailure();
    return callbacks.orElse();
  }
}

export type HomeFailure = ServerFailure | NetworkFailure;

export const HomeFailure = {
  serverFailure: () => new ServerFailure(),
  networkFailure: () => new NetworkFailure(),
};
